import { useContext } from 'react'

import { AccountFormContext } from '../context'

export function useGroups() {
  const {
    groups,
    loadingGroups: loading,
    listGroups
  } = useContext(AccountFormContext)

  return {
    groups,
    loading,
    listGroups
  }
}
